import React from "react";
import { useForm, ValidationError } from "@formspree/react";

import "../blocks/Contact.css";

function ContactForm() {
  const [state, handleSubmit] = useForm("xbjnwqak");

  return (
    <section className="contact" id="contact">
      <div className="contact__container">
        <header className="contact__header">
          <p className="contact__eyebrow">CONTACTO</p>
          <p className="contact__intro">
            Cuéntanos sobre ti, tu sala, festival o evento y coordinamos el
            próximo directo de Carmen Supermarket.
          </p>
        </header>

        {state.succeeded ? (
          <div className="contact__success">
            <h3>¡Gracias!</h3>
            <p>
              Hemos recibido tu mensaje y te responderemos muy pronto. Mientras
              tanto, sigue nuestro día a día en
              <a
                className="contact__success-link"
                href="https://www.instagram.com/carmensupermarket/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
              para no perderte ningún anuncio.
            </p>
          </div>
        ) : (
          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__field">
              <label className="contact__label" htmlFor="name">
                Nombre
              </label>
              <input
                id="name"
                type="text"
                name="name"
                className="contact__input"
                autoComplete="name"
                required
              />
              <ValidationError
                prefix="Name"
                field="name"
                errors={state.errors}
                className="contact__error"
              />
            </div>

            <div className="contact__field">
              <label className="contact__label" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                className="contact__input"
                autoComplete="email"
                required
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
                className="contact__error"
              />
            </div>

            <div className="contact__field">
              <label className="contact__label" htmlFor="message">
                Mensaje
              </label>
              <textarea
                id="message"
                name="message"
                className="contact__textarea"
                rows="4"
                required
              />
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
                className="contact__error"
              />
            </div>

            <button
              type="submit"
              className="contact__submit"
              disabled={state.submitting}
            >
              Enviar mensaje
            </button>
          </form>
        )}
      </div>
    </section>
  );
}

export default ContactForm;
